<template>
  <div>
    <title-model-a icon="search" title="Consulta el estado de los dominios" />

    <v-row class="my-4 px-2">
      <v-text-field
        v-if="isManualMode"
        v-model="localDomainName"
        clearable
        hide-details
        outlined
        placeholder="Escribe el dominio a consultar"
        type="text"
        @input="$emit('update:domainName', $event)"
      />

      <FinderSelector
        v-else
        v-model="localAccountId"
        :hide_value="true"
        icon="email"
        placeholder="Selecciona una cuenta"
        text_name="name"
        text_value="id"
        url="app-center/commservices/email-accounts"
        @input="$emit('update:accountId', $event)"
      />
    </v-row>

    <v-row class="px-2" justify="space-between">
      <v-col class="pa-0" cols="4">
        <v-select
          v-model="localSearchMode"
          :items="searchModeOptions"
          dense
          hide-details
          outlined
          @change="$emit('update:searchMode', $event)"
        />
      </v-col>

      <v-col>
        <v-row justify="end">
          <button-icon-text-model-b
            v-if="!isManualMode && !localAccountId"
            :disabled="!service_user.checkGroupPermission(P_COMMSERVICES_EXCLUSION_LIST_EDIT)"
            class="ml-2"
            icon="add"
            text="Añadir"
            @click="$emit('add-account')"
          />

          <button-icon-text-model-b
            v-else-if="!isManualMode"
            :disabled="!service_user.checkGroupPermission(P_COMMSERVICES_EXCLUSION_LIST_EDIT)"
            class="ml-2"
            icon="create"
            text="Modificar"
            @click="$emit('edit-account')"
          />

          <button-icon-text-model-b
            :disabled="!canSearch"
            class="ml-2"
            icon="search"
            text="Consultar"
            @click="$emit('search')"
          />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ButtonIconTextModelB from "@/components/repository/buttons/ButtonIconTextModelB.vue";
import TitleModelA from "@/components/repository/TitleModelA.vue";
import FinderSelector from "@/components/repository/fields/FinderSelector.vue";
import helpers from "@/plugins/helpers";
import { P_COMMSERVICES_EXCLUSION_LIST_EDIT } from "@/constants/group_permissions";
import service_user from "@/services/service_user";

export default {
  name: "DomainSearchForm",
  components: {
    ButtonIconTextModelB,
    TitleModelA,
    FinderSelector
  },
  props: {
    domainName: {
      type: String,
      default: ""
    },
    accountId: {
      type: [String, Number],
      default: null
    },
    searchMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      P_COMMSERVICES_EXCLUSION_LIST_EDIT,
      localDomainName: this.domainName,
      localAccountId: this.accountId,
      localSearchMode: this.searchMode,
      searchModeOptions: [
        { text: "Dominio", value: true },
        { text: "Selector de cuenta", value: false }
      ]
    };
  },
  computed: {
    service_user() {
      return service_user;
    },
    isManualMode() {
      return this.localSearchMode;
    },
    canSearch() {
      if (this.isManualMode) {
        return !helpers.nullOrEmpty(this.localDomainName);
      }
      return !helpers.nullOrEmpty(this.localAccountId);
    }
  },
  watch: {
    domainName(val) {
      this.localDomainName = val;
    },
    accountId(val) {
      this.localAccountId = val;
    },
    searchMode(val) {
      this.localSearchMode = val;
    }
  }
};
</script>
